webpackJsonp([1],{

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//

exports.default = function () {
    return _react2.default.createElement(
        'i',
        null,
        'beatfix'
    );
};

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//

exports.default = function () {
    return _react2.default.createElement(
        'a',
        { href: 'http://www.freshcode.biz' },
        _react2.default.createElement(
            'strong',
            null,
            'freshcode.biz'
        )
    );
};

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Product = __webpack_require__(137);

var _Product2 = _interopRequireDefault(_Product);

var _Provider = __webpack_require__(140);

var _Provider2 = _interopRequireDefault(_Provider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//

exports.default = function () {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'h1',
            null,
            'About'
        ),
        _react2.default.createElement(
            'h2',
            null,
            'Background'
        ),
        _react2.default.createElement(
            'p',
            null,
            'Hi, my name is Peter, an amateur drummer for over 10 years. I\'ve never used a \'click track\' and instead rely on a visual metronome when onstage to ensure correct tempo, especially to start a song. A performance metronome has a number of different requirements to a conventional metronome. In general, it needs to be passive, flexible, quickly adjustable and work in the dark.'
        ),
        _react2.default.createElement(
            'p',
            null,
            'In my experience, the ',
            _react2.default.createElement(
                'i',
                null,
                'Matrix MR600 DLX'
            ),
            ' metronome is very good for performance usage although not perfect. Also, using the MR600, I found I could monitor and fix my tempo during a performance if necessary.'
        ),
        _react2.default.createElement(
            'p',
            null,
            'Being a software developer by trade, I thought I\'d come up with my own metronome. ',
            _react2.default.createElement(_Product2.default, null),
            ' is the second generation solution. The first was ',
            _react2.default.createElement(
                'a',
                { href: 'https://sourceforge.net/projects/multi-phasemetr/' },
                'Multi-phase Metronome'
            ),
            ' and it worked reasonably well.'
        ),
        _react2.default.createElement(
            'h2',
            null,
            'Announcements'
        ),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
                'a',
                { href: 'https://groups.google.com/forum/#!forum/beatfixlive-announcements' },
                'Join the mailing list'
            ),
            ' to receive an email when a new version is released.'
        ),
        _react2.default.createElement(
            'h2',
            null,
            'Release Notes'
        ),
        _react2.default.createElement(
            'p',
            null,
            'Available from the ',
            _react2.default.createElement(
                'a',
                { href: 'https://subversion.assembla.com/svn/freshcode_public/beatfix.live/app/RELEASE_NOTES.txt' },
                'online source code repository'
            ),
            '.'
        ),
        _react2.default.createElement(
            'h2',
            null,
            _react2.default.createElement(_Product2.default, null),
            ' is a ',
            _react2.default.createElement(_Provider2.default, null),
            ' innovation'
        )
    );
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/About.f2c93edc.js